import React, {useEffect} from 'react'

const Section4 = ({products, select, setSelect, setStep}) =>{

    let dataset = [];
    let selectedLengthIndex = 0;
    // let course = parseFloat(document.querySelector('#course').innerText)

    if (select.cutStyle){

        products[select.material].properties.sizes.length_grouping.forEach((elem,index) => {
            if (parseFloat(elem.length) === select.length) {
                selectedLengthIndex += index;
                return null;
            }
        });
        
        dataset = products[select.material].properties.sizes.length_grouping[selectedLengthIndex].count_n_price

    }else{

        products[select.material].properties.sizes.length_grouping.forEach((elem,index) => {

            if (parseFloat(elem.length) === select.length) {
                selectedLengthIndex += index;
                return null;
            }
        });

        dataset = products[select.material].properties.sizes.length_grouping[selectedLengthIndex].roll_n_price
    }

    dataset = dataset.filter((item) => { //remove empty or not correctly filled count/price pairs
        if ((parseInt(item.product_count) > 0) && (parseFloat(item.product_price) > 0)) {
            return true;
        } else {
            return false;
        }
    });


    function onButtonClick(){
        if (document.querySelector(".calc_amounts input:checked") === null) {
            alert(window.lang['s4']['select_amount']);
            return false;
        }

        let price = parseFloat(document.querySelector(".calc_amounts input:checked").dataset.price);
        let amount = parseFloat(document.querySelector(".calc_amounts input:checked").dataset.count);

        if (isNaN(price) || isNaN(amount)){
            return false;
        }

        setSelect({
            ...select,
            basicPrice: {
                ...select.basicPrice,
                priceForAmout: price
            },
            amount: amount
        });
        setStep(5);
    }

    function goBack(){
        setSelect({
            ...select,
            basicPrice: {
                ...select.basicPrice,
                priceForAmout: 0
            },
            amount: 0
        });
        setStep(3)
    }

    function addRollLabel(amount){
        if ( select.cutStyle === true ) return window.lang['s']['units']['count']

        let reducedAmount = amount % 100
        if (reducedAmount >= 10 && reducedAmount <= 19) return window.lang['s']['rolls']

        reducedAmount = reducedAmount % 10
        if ([1].includes(reducedAmount) ) return window.lang['s']['roll']
        if ([2,3,4].includes(reducedAmount) ) return window.lang['s']['roll_234']
        if ([5,6,7,8,9,0].includes(reducedAmount) ) return window.lang['s']['rolls']

        return null
    }

    useEffect(() =>{
        document.querySelectorAll('#amount-container input').forEach((item) => {
            if (parseInt(item.dataset.count) === parseInt(select.amount)) item.checked = true
        })
        if (document.querySelectorAll('#amount-container input:checked') === null){
            document.querySelector('#amount-container').scrollIntoView({block: "center", behavior: "smooth"})
        }
    })

    return(
        <>
            <div className="section_header">
                <h1>{window.lang['s4']['title']}</h1>
                <div className="step-btns">
                    <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s4']['btn_back']}</span></button>
                    <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s4']['btn_next']}</span></button>
                </div>
            </div>

            <div className="count">
                <p>{(select.cutStyle) ? window.lang['s4']['items_amount'] :`${window.lang['s4']['items_amount']} ${select.roll_length} ${window.lang['s']['units']['meters']}`}</p>
                <div id="amount-container">
                    {dataset.map((item,index) =>{
                        return(
                            <span className="calc_amounts" key={index}>
                            <label htmlFor={'amount_'+index}>
                                <input  type="radio"
                                        name="amount_option" 
                                        id={'amount_'+index} 
                                        data-count={item.product_count} 
                                        data-price={item.product_price}
                                        />
                                {item.product_count} {addRollLabel(item.product_count)}
                            </label>
                            </span>
                        )
                    })}
                </div>
            </div>

            <div className="step-btns">
                <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s4']['btn_back']}</span></button>
                <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s4']['btn_next']}</span></button>
            </div>
        </>
    )
}

export default Section4;

/*

(от {item.product_price} $ / {item.product_price*course} грн.)


*/